import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player/lazy'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'
import './gameVideoModal.scss'

const Alert = ({ type = '', isActive = false, children }) => {
  return (
    <span
      className={`f-game-alert f-game-alert--${type} ${
        isActive ? 'f-game-alert--active' : ''
      }`}
    >
      {children}
    </span>
  )
}

const GameVideoModal = ({ onSkipVideo, onFinishVideo }) => {
  const [activeAlert, setActiveAlert] = useState()
  const [played, setPLayed] = useState(0)
  const START_ICON_CODE = '&#9734;'

  const clearWarning = ({ time = 3000, onClearWarning }) => {
    setTimeout(() => {
      setActiveAlert(null)
      onClearWarning && onClearWarning()
    }, time)
  }

  const dispatchInitialWarning = () => {
    setActiveAlert('initial')
    clearWarning({ time: 5000 })
  }

  const handleFinishVideo = () => {
    setActiveAlert('points')
    clearWarning({ onClearWarning: onFinishVideo })
  }

  const handleSkipVideo = () => {
    videoTimeDataLayer(played)
    onSkipVideo()
  }

  const startdataLayer = () => {
    pushEventDataLayer(
      'Interacciones - Video',
      'cur-v-shooter',
      'click video',
      'imagen'
    )
  }
  const videoTimeDataLayer = seconds => {
    pushEventDataLayer(
      'Interacciones - Video',
      'cur-v-shooter',
      'click video',
      `${seconds}s`
    )
  }

  return (
    <div className="f-gameVideoModal">
      <div className="f-gameVideoModal__container">
        <Alert type="initial" isActive={activeAlert === 'initial'}>
          <b>¡Dale play al video!</b> Te ayudará a resolver el reto{' '}
          <b>y ganarás 6 puntos adicionales.</b>
        </Alert>

        <button
          className="f-gameVideoModal__container__skip"
          onClick={handleSkipVideo}
        >
          SKIP
        </button>
        <div className="f-gameVideoModal__container__video">
          <ReactPlayer
            url="https://www.youtube.com/watch?v=dT4c-a6jToE&ab_channel=Nosotras"
            controls={false}
            width="100%"
            height="100%"
            onReady={dispatchInitialWarning}
            onEnded={handleFinishVideo}
            onPlay={startdataLayer}
            onProgress={progress => setPLayed(progress.playedSeconds)}
          />
        </div>

        <Alert type="points" isActive={activeAlert === 'points'}>
          <span
            className="f-gameVideoModal__container__alert__start"
            dangerouslySetInnerHTML={{ __html: START_ICON_CODE }}
          />{' '}
          <b>Ganaste 6 puntos</b>
        </Alert>
      </div>
    </div>
  )
}

export default GameVideoModal
